// Which site the app is being served as. The same build answers at:
//   admin.runthe.club  the Run The Club admin site (super admin portal only)
//   app.runthe.club    Run The Club sign in for every club
//   anything else      a club's own site (trampoline.life)
export const ADMIN_HOST = 'admin.runthe.club';
export const ADMIN_URL = `https://${ADMIN_HOST}`;
export const APP_HOST = 'app.runthe.club';
export const APP_URL = `https://${APP_HOST}`;
// The Run The Club sales site, home for app.runthe.club and admin.runthe.club
export const MARKETING_URL = 'https://runthe.club';

export const isAdminSite = (hostname = window.location.hostname) =>
  hostname === ADMIN_HOST || process.env.REACT_APP_ADMIN_SITE === 'true';

// app.runthe.club: no club's name until someone signs in, and no public club
// pages or sign-up (those belong to a club's own site)
export const isPlatformSite = (hostname = window.location.hostname) =>
  hostname === APP_HOST || process.env.REACT_APP_PLATFORM_SITE === 'true';

// The name on the sign-in and password pages
export const siteName = (hostname = window.location.hostname) =>
  (isPlatformSite(hostname) || isAdminSite(hostname) ? 'Run The Club' : 'Trampoline Life');

// Run The Club's own icon on its sites (a dark one on the admin site, so its
// tabs stand out from the app's); elsewhere the page's usual icon
export const RTC_FAVICON = '/rtc-favicon.png';
export const RTC_ADMIN_FAVICON = '/rtc-admin-favicon.svg';
export const setFavicon = (href, hostname = window.location.hostname) => {
  const link = document.getElementById('favicon');
  if (!link) return;
  const admin = isAdminSite(hostname);
  link.href = admin ? RTC_ADMIN_FAVICON : isPlatformSite(hostname) ? RTC_FAVICON : href;
  link.type = admin ? 'image/svg+xml' : 'image/png';
};
